import { navigateLeftStack } from '@/app/store';
import { IconBoxArrowDown } from '@/assets/images';
import { AppIcon, ListTile } from '@/components';
import { useLanguage } from '@/localization/useLanguage';
import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectArchivedChats } from '../../model';
import './archivedChatEntre.scss';

const ArchivedChatEntry = () => {
   const { t } = useLanguage();
   const dispatch = useDispatch();
   const { archived } = useSelector(selectArchivedChats);

   const handleOpenArchived = useCallback(() => {
      dispatch(navigateLeftStack({ activeStack: 'chats', subStack: 'archived' }));
   }, [dispatch]);

   if (archived?.length === 0) return null;

   const unreadCount = archived.reduce((acc, chat) => acc + (chat.unreadCount > 0 ? 1 : 0), 0);

   return (
      <ListTile
         as="div"
         className="archived-chat-entry"
         avatar={<AppIcon icon={<IconBoxArrowDown />} />}
         title={t('chat.ARCHIVED_TITLE')}
         trailing={unreadCount > 0 && <span className="unread-count">{unreadCount}</span>}
         onClick={handleOpenArchived}
      />
   );
};

export default React.memo(ArchivedChatEntry);
